// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"faq_wrapper__A6ZsQ","background":"faq_background__8zgf0","container":"faq_container__e1BL9","contentContainer":"faq_contentContainer__4eqoh","title":"faq_title__qAtLj"};